import { CallEffect, ForkEffect, GetContextEffect, PutEffect } from 'redux-saga/effects';
import { getContext, call, put, takeLatest } from 'typed-redux-saga';
import { IDependencies } from '../../../../../cross-cutting-concerns/dependency-injection/interfaces/IDependencies';
import {
  IGetSiteListWithOperatingTimeRequestAction,
  IGetSiteListWithOperatingTimeSuccessAction,
  IGetSiteListWithOperatingTimeErrorAction,
  SiteWidgetsFleetDashboardActions,
} from './siteWidgetsFleetDashboardActions';
import { SiteListWithOperatingTime } from 'app/modules/site-management/interfaces/Site.types';
import { MachinesListWithCleaningReport } from 'app/modules/machine-inventory/interfaces/Machine.types';
import { SiteOperatingTimePeriod } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { SitePerformanceChartUtils } from 'app/modules/site-management/widgets/fleet-dashboard/utils/SitePerformanceChartUtils';
import { OpenSearch } from 'config/constants';

export function* getSiteListWithOperatingTimeSaga(
  action: IGetSiteListWithOperatingTimeRequestAction
): Generator<
  | GetContextEffect
  | CallEffect<SiteListWithOperatingTime>
  | CallEffect<MachinesListWithCleaningReport>
  | PutEffect<IGetSiteListWithOperatingTimeSuccessAction>
  | PutEffect<IGetSiteListWithOperatingTimeErrorAction>,
  void,
  IDependencies
> {
  const { siteService, machineService } = yield* getContext<IDependencies>('dependencies');
  const { paginationOptions, sortOptions, period, filter, noSiteMachineIds } = action.payload;

  try {
    const response = yield* call(siteService.listSitesWithOperatingTime, {
      paginationOptions,
      sortOptions,
      period,
      filter,
    });

    let noSiteMachinesOperatingTime: SiteOperatingTimePeriod | null = null;

    if (noSiteMachineIds && noSiteMachineIds.length > 0) {
      const machinesResponse = yield* call(machineService.listMachinesWithOperatingTime, {
        filter: { ids: noSiteMachineIds },
        period,
        paginationOptions: { limit: OpenSearch.MAX_RESULT_WINDOW },
      });
      noSiteMachinesOperatingTime = SitePerformanceChartUtils.sumNoSiteMachinesOperatingTime(
        machinesResponse.machines,
        period
      );
    }

    yield* put(
      SiteWidgetsFleetDashboardActions.getSiteListWithOperatingTimeSuccess({
        ...response,
        noSiteMachinesOperatingTime,
      })
    );
  } catch (error) {
    yield* put(
      SiteWidgetsFleetDashboardActions.getSiteListWithOperatingTimeError({
        error,
      })
    );
  }
}

export function* siteWidgetsFleetDashboardSaga(): Generator<ForkEffect<never>, void> {
  yield* takeLatest(
    SiteWidgetsFleetDashboardActions.GET_SITE_LIST_WITH_OPERATING_TIME_REQUEST,
    getSiteListWithOperatingTimeSaga
  );
}
